exports.onClientEntry = () => {
  if (window.location.pathname.endsWith("/conteudo/17396/inep-volta-a-ficar-sem-presidente")) {
    window.embeddedChatbotConfig = {
      chatbotId: "A_S0Isxu1rHhWLT0RPmS3",
      domain: "www.chatbase.co",
    };

    const script$ = document.createElement("script");

    script$.src = "https://www.chatbase.co/embed.min.js";
    script$.setAttribute("chatbotId", "A_S0Isxu1rHhWLT0RPmS3");
    script$.setAttribute("domain", "www.chatbase.co");
    script$.defer = true;

    window.document.body.insertAdjacentElement("beforeend", script$);
  }
};
